<template>
    <div>
        <div>
            <ol class="breadcrumb">
                <li><a href="backend">Inicio</a></li>
                <li>Notificaciones</li>
                <li class="active">Envíos</li>
            </ol>
        </div>

        <h4 id=titulo>Aquí puede cargar su archivo .csv para enviar notificaciones a los ciudadanos</h4>
        <br>

        <form @submit="checkForm" action='/backend/enviarnotificacion#titulo' method='POST'
              class="page-form" enctype="multipart/form-data">
            <div class="form-group">
                <label for="tipoNotificacion">Tipo de Notificación</label>
                <select id="tipoNotificacion" name="tipoNotificacion" class="form-control">
                    <option value="0" id="sel1" selected>Seleccionar</option>
                    <option v-for="tipo in data.tipo_notif" :value="tipo.id">{{ tipo.nombre }}</option>
                </select>
            </div>

            <div v-if="role == 'admin'" class="form-group">
                <label for="tipoOrganizacion">Institución</label>
                <select name="tipoOrganizacion" class="form-control">

                    <option value="0" id="sel2" selected>Seleccionar</option>
                    <option v-for="organizacion in data.organizaciones" :value="organizacion.id"> {{ organizacion.name }}</option>

                </select>
            </div>
            <div v-else class="form-group">
                <label for="tipoOrganizacion">Institución</label>
                <select disabled="true" id="tipoOrganizacion"
                        name="tipoOrganizacion" class="form-control">
                    <option :value="data.organizaciones.id" id="sel3" selected> {{ data.organizaciones.name }}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="TipoSaludo">Tipo de Saludo:</label>
                <input v-model="data.tipo_saludo" type="text" class="form-control" id="tipoSaludo" name="tipoSaludo"
                       placeholder="Ingrese el tipo de saludo: Estimado(a), Hola, Buen día..." required>
            </div>

            <div class="form-group">
                <label for="asunto">Asunto</label>
                <input v-model="data.asunto" class="form-control" type="text" name="asunto" id="asunto" required>
            </div>

            <div class="form-group">
                <label for="asunto">Descripción de la notificación</label>
                <editor id="description" name="descripcion" v-model="data.descripcion" aria-required="true"></editor>
            </div>

            <div class="form-group">
                <label for="asunto">Link adjunto (opcional)</label>
                <input class="form-control" type="url" id="link" name="link" v-model="data.link" />
            </div>

            <div class="form-group">
                <label for="rutCsv">Lista de RUN: </label>
                <p>Formato .csv</p>
                <el-upload action="backend/api/csv" :headers="{'X-CSRF-TOKEN': token, 'X-Requested-With': 'XMLHttpRequest'}"
                           :on-change="fileUploadChanged" :show-file-list="false">
                    <el-button size="small" type="primary">Click para subir archivo</el-button>

                </el-upload>
                <p>{{ this.data.csv }}</p>
            </div>

            <div v-if="errors.length">
                <b style="color:red;">Por favor, revise los siguientes errores:</b>
                <ul>
                    <li style="color:red;" v-for="error in errors">{{ error }}</li>
                </ul>
            </div>

            <div v-if="success">
                <div class="alert alert-success alert-dismissable">
                    La notificación ha sido ingresada exitosamente
                </div>
            </div>

            <input :disabled="errors==true" name='submit' class="btn btn-primary"
                   type="submit" value="Enviar notificación">

            <input type="hidden" name="_token" :value="token">
            <input type="hidden" name="csv" :value="data.csv">
        </form>
    </div>
</template>

<style lang="scss">
    .page-form{
        .el-select{
            display: block;
        }
        .el-upload{
            .el-upload__input{
                display: none;
            }
        }
    }
</style>
<script>
    import ElUpload from 'element-ui/lib/upload';
    import ElButton from 'element-ui/lib/button';
    import Editor from './Editor.vue';

    export default {
        name: "SendNotification",
        props: ['organizaciones', 'tipo_notif', 'role'],

        data: function (){
            let organizaciones  = _.cloneDeep(this.organizaciones);
            let tipo_notif = _.cloneDeep(this.tipo_notif);
            return{
                token: window.token.content,
                errors: true,
                success: false,
                data:{
                    tipo_saludo: null,
                    tipo_notif: tipo_notif,
                    organizaciones: organizaciones,
                    descripcion: null,
                    csv: null,
                    link: null,
                    asunto: null,
                }
            }
        },
        components:{
            ElUpload,
            ElButton,
            Editor,
        },
        methods:{
            submit: function (){
                let self = this;
                    axios({
                        url:  'backend/enviarnotificacion',
                        method: 'POST',
                        data: self.data,
                    }).then(function(response){

                    }).catch(function(error){

                    });
            },
            fileUploadChanged: function(file){
                if (file.raw.type != 'application/vnd.ms-excel') {
                    alert("El archivo debe ser de formato .csv");
                }else{
                    if(file.status == "success"){
                        this.data.csv = file.response;
                        this.errors = false;
                    }else if (file.status == "fail"){
                        alert("No se pudo subir archivo");
                        this.errors = true;
                    }
                }
            },
            checkForm: function (e){
                this.errors = [];

                if (!this.data.tipo_saludo) {
                    this.errors.push("Ingrese un saludo");
                }
                if ($('#tipoNotificacion option:selected').val() <= 0){
                    this.errors.push("Seleccione un tipo de notificación");
                }

                if ($('#tipoOrganizacion option:selected').val() <= 0){
                    this.errors.push("Seleccione una organización");
                }
                if (!this.data.descripcion){
                    this.errors.push("Ingrese una descripción");
                }

                if (!this.errors.length) {
                    this.success = true;
                    return true;
                }
                e.preventDefault();
            }
        },
    }
</script>

<style scoped>

</style>